import { render, staticRenderFns } from "./dictionaryTable.vue?vue&type=template&id=49c1a531&scoped=true&"
import script from "./dictionaryTable.vue?vue&type=script&lang=js&"
export * from "./dictionaryTable.vue?vue&type=script&lang=js&"
import style0 from "./dictionaryTable.vue?vue&type=style&index=0&id=49c1a531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1a531",
  null
  
)

export default component.exports